import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function authConfig() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function getCpLedgerSummary() {
  const res = await axios.get(`${API_URL}/api/cp-ledger/summary`, authConfig());
  return res.data;
}

export async function getCpLedgerStatement(counterpartyKey) {
  const res = await axios.get(
    `${API_URL}/api/cp-ledger/statement/${encodeURIComponent(counterpartyKey)}`,
    authConfig()
  );
  return res.data;
}
